/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Icon, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { URL } from 'src/constants/links';
import { ARTICLE3 } from 'src/constants/onboarding';

type Props = {
  name: string
};

type ComposedProps = Props & WithI18nProps;

class OnboardingArticles3 extends Component<ComposedProps> {
  render() {
    const { name, i18n } = this.props;
    const contents = ARTICLE3;

    const content = contents[name] || [];

    // Empty name
    if (_.isEmpty(content)) {
      return '';
    }

    return (
      <React.Fragment>
        <p>{i18n.translate('AdminHTML.Dashboard.OnboardingArticles.paragraph')}</p>
        <div className="segment">
          {_.map(content, (item, index) => (
            <p className="list-feature" key={index}>
              <span className="icon">
                <Icon source={item.icon} color="indigo" />
              </span>
              {i18n.translate(item.title)}
              <span style={{ marginLeft: '2px' }}>
                <Link onClick={() => {
                  this.openLink(item.url);
                }}>
                  {i18n.translate('AdminHTML.Dashboard.OnboardingArticles.link')}
                </Link>
              </span>
            </p>
          ))}
        </div>
      </React.Fragment>
    );
  }

  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };
}

export default withI18n()(OnboardingArticles3);
